import type { DateTime } from 'luxon'

// Allowed states the user can switch to
export type AvailabilitiesUpdateTargetKind =
  | SlotType.EMPTY
  | SlotType.UNAVAILABLE
  | SlotType.AVAILABLE

export type AvailabilitiesDateSlot = {
  date: DateTime
  period: string
}

export enum SlotType {
  SHIFT = 'shift',
  AVAILABLE = 'available',
  BUSY = 'busy',
  UNAVAILABLE = 'unavailable',
  EMPTY = 'empty',
}

export type SlotTypeUpdatable =
  | SlotType.AVAILABLE
  | SlotType.UNAVAILABLE
  | SlotType.EMPTY

export type SlotShift = {
  id: number
  beginAt: string
  endAt: string
  timezone: string
}
export type Slot = {
  institutionName?: string
  formattedSlotStart?: string
  formattedSlotEnd?: string
  idPeriod: string
  day: string
} & (
  | {
      type: Exclude<SlotType, SlotType.SHIFT>
    }
  | {
      shifts: SlotShift[]
      type: SlotType.SHIFT
    }
)
